import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageFooter from './components/pageFooter';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import { useCart } from '../context/CartContext';
import './NailCommissionPage.css';

import { API_URL } from '../config';


const SHAPES = ['Almond', 'Stiletto', 'Round'];
const LENGTHS = ['Extra Short', 'Short', 'Medium'];

export const NailCommissionPage = () => {
    const { addToCart } = useCart();
    const [form, setForm] = useState({
        shape: '', length: '',
        sizes: '', designDetails: '', name: '', contactInfo: '',
        contactMethod: '', dateNeeded: '',
    });
    const [submitted, setSubmitted] = useState(false);
    const [notifyEmail, setNotifyEmail] = useState('');
    const [notifySubmitted, setNotifySubmitted] = useState(false);
    const [slots, setSlots] = useState({ maxCommissions: 5, currentCommissions: 0, isFull: false });
    const [loading, setLoading] = useState(true);
    const [refImages, setRefImages] = useState([]);
    const objectUrlsRef = useRef([]);

    useEffect(() => {
        const urls = objectUrlsRef.current;
        return () => {
            urls.forEach((url) => URL.revokeObjectURL(url));
        };
    }, []);

    useEffect(() => {
        fetch(`${API_URL}/api/commissions/status`)
            .then((r) => r.json())
            .then((data) => setSlots(data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

    const isRush = (() => {
        if (!form.dateNeeded) return false;
        const needed = new Date(form.dateNeeded + 'T00:00:00');
        const twoWeeks = new Date();
        twoWeeks.setDate(twoWeeks.getDate() + 14);
        return needed <= twoWeeks;
    })();

    const [formErrors, setFormErrors] = useState([]);

    const getErrors = () => {
        const errors = [];
        if (!form.shape) errors.push('nail shape is required');
        if (!form.length) errors.push('nail length is required');
        if (!form.sizes) errors.push('nail sizes are required');
        if (!form.name) errors.push('your name is required');
        if (!form.contactMethod) errors.push('preferred contact method is required');
        if (!form.contactInfo) errors.push(form.contactMethod === 'Phone' ? 'phone number is required' : 'email is required');
        if (!form.dateNeeded) errors.push('date needed by is required');
        return errors;
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files).slice(0, 5 - refImages.length);
        const newUrls = files.map((f) => URL.createObjectURL(f));
        objectUrlsRef.current.push(...newUrls);
        setRefImages((prev) => [...prev, ...files.map((f, i) => ({ file: f, url: newUrls[i] }))].slice(0, 5));
    };
    const removeImage = (idx) => {
        URL.revokeObjectURL(refImages[idx]?.url);
        setRefImages((prev) => prev.filter((_, i) => i !== idx));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = getErrors();
        if (errors.length > 0) {
            setFormErrors(errors);
            return;
        }
        setFormErrors([]);
        const price = isRush ? 85 : 65;

        let uploadedFiles = [];
        if (refImages.length > 0) {
            const fd = new FormData();
            refImages.forEach((r) => fd.append('images', r.file));
            try {
                const upRes = await fetch(`${API_URL}/api/upload`, { method: 'POST', body: fd });
                const upData = await upRes.json();
                uploadedFiles = upData.files || [];
            } catch { /* continue without images */ }
        }

        const commissionData = {
            shape: form.shape,
            length: form.length,
            sizes: form.sizes,
            name: form.name,
            contactMethod: form.contactMethod,
            contactInfo: form.contactInfo,
            rushOrder: isRush,
            dateNeeded: form.dateNeeded,
            designDetails: form.designDetails || 'none',
            referenceImages: uploadedFiles,
            price,
        };
        // Verify slots are still available (don't consume yet — saved after payment in checkout)
        try {
            const statusRes = await fetch(`${API_URL}/api/commissions/status`);
            const statusData = await statusRes.json();
            if (statusData.isFull) {
                alert('Commissions just filled up. Please try again later.');
                return;
            }
        } catch {
            alert('Could not reach server. Please try again.');
            return;
        }
        addToCart({
            id: `custom-commission-${Date.now()}`,
            title: 'Custom Commission',
            price,
            image: require('../images/nails/winter.JPG'),
            options: commissionData,
            pendingCommission: commissionData,
        });
        setSubmitted(true);
    };

    if (submitted) {
        return (
            <PageLayout><PageContainer><PageBody>
                <NavigationHeader />
                <PageText>
                    <div className="commission-container commission-success">
                        <p>custom order added to cart ✧</p>
                        <p className="commission-note">joy will reach out via {form.contactMethod.toLowerCase()} to confirm design details.</p>
                        <div className="commission-success-links">
                            <Link to="/cart" className="commission-btn">go to cart →</Link>
                            <Link to="/shop" className="commission-btn">continue shopping →</Link>
                        </div>
                    </div>
                </PageText>
                <PageFooter />
            </PageBody></PageContainer></PageLayout>
        );
    }

    return (
        <PageLayout>
            <PageContainer>
                <PageBody>
                    <NavigationHeader />
                    <PageText>
                        <div className="commission-container">
                            <h2 className="commission-title">⟡₊ ⊹ custom press-on order form ⟡₊ ⊹</h2>

                            <div className="commission-past-gallery">
                                <p className="commission-past-label">✧ past commissions ✧</p>
                                <p className="commission-past-sublabel">inspo given → finished result</p>
                                {[
                                    { result: require('../images/nails/IMG_2812.jpg'), inspo: require('../images/nails/IMG_2812_INSPO.png.JPEG') },
                                    { result: require('../images/nails/IMG_3784.jpeg'), inspo: require('../images/nails/IMG_3784_INSPO.jpg') },
                                    { result: require('../images/nails/IMG_7255.jpeg'), inspo: require('../images/nails/IMG_7255_INSPO.JPG') },
                                    { result: require('../images/nails/IMG_8235.jpg'), inspo: require('../images/nails/IMG_8235_INSPO.JPG') },
                                ].map((item, i) => (
                                    <div key={i} className="commission-past-entry">
                                        <div className="commission-past-col">
                                            <span className="commission-col-label">inspo</span>
                                            <img src={item.inspo} alt={`inspo ${i + 1}`} className="commission-past-img" />
                                        </div>
                                        <div className="commission-past-arrow">→</div>
                                        <div className="commission-past-col">
                                            <span className="commission-col-label">finished</span>
                                            <img src={item.result} alt={`commission ${i + 1}`} className="commission-past-img" />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="commission-info">
                                <p>each order comes with:</p>
                                <ul className="commission-list">
                                    <li>✧ 1 nail prep kit</li>
                                    <li>✧ 1 set of adhesive tabs</li>
                                    <li>✧ 1 storage box + stickers</li>
                                </ul>
                                <p className="commission-note">total price calculated after discussing design complexity.</p>
                                <p className="commission-note">nails take up to 2 weeks to prepare and ship.</p>
                                <p className="commission-note">questions? DM <a href="https://instagram.com/egg.tarty" target="_blank" rel="noopener noreferrer">@egg.tarty</a> on instagram</p>
                                {!slots.isFull && <p className="commission-note">{slots.maxCommissions - slots.currentCommissions} slots available</p>}
                            </div>

                            {loading ? (
                                <p className="commission-note" style={{ textAlign: 'center' }}>loading...</p>
                            ) : slots.isFull ? (
                                <div className="commission-full-overlay">
                                    <p className="commission-full-text">commissions are currently full ✧</p>
                                    <p className="commission-note">all {slots.maxCommissions} slots are taken. leave your email to be notified when a spot opens up.</p>
                                    {notifySubmitted ? (
                                        <p className="commission-notify-thanks">we'll let you know when slots open up ✧</p>
                                    ) : (
                                        <div className="commission-notify-form">
                                            <input
                                                type="email"
                                                placeholder="your email"
                                                value={notifyEmail}
                                                onChange={(e) => setNotifyEmail(e.target.value)}
                                                className="form-input"
                                            />
                                            <button
                                                className="commission-btn"
                                                disabled={!notifyEmail}
                                                onClick={() => {
                                                    fetch(`${API_URL}/api/commissions/notify`, {
                                                        method: 'POST',
                                                        headers: { 'Content-Type': 'application/json' },
                                                        body: JSON.stringify({ email: notifyEmail }),
                                                    }).then(() => setNotifySubmitted(true)).catch(() => setNotifySubmitted(true));
                                                }}
                                            >
                                                notify me
                                            </button>
                                        </div>
                                    )}
                                    <Link to="/shop" className="commission-btn" style={{ marginTop: 16 }}>browse shop →</Link>
                                </div>
                            ) : (

                            <form onSubmit={handleSubmit} className="commission-form">
                                <div className="form-group">
                                    <label className="form-label">nail shape *</label>
                                    <div className="form-radios">
                                        {SHAPES.map((opt) => (
                                            <label key={opt} className="form-radio">
                                                <input type="radio" name="shape" value={opt} checked={form.shape === opt} onChange={(e) => setForm({ ...form, shape: e.target.value, length: form.length === 'Extra Short' && e.target.value !== 'Round' ? '' : form.length })} />
                                                <span>{opt}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">nail length *</label>
                                    <div className="form-radios">
                                        {LENGTHS.filter((opt) => opt !== 'Extra Short' || form.shape === 'Round').map((opt) => (
                                            <label key={opt} className="form-radio">
                                                <input type="radio" name="length" value={opt} checked={form.length === opt} onChange={update('length')} />
                                                <span>{opt}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">nail sizes *</label>
                                    <p className="form-hint">measure the width of each nail in mm. standard sizes:</p>
                                    <div className="sizing-ref">
                                        <p>XS: 14, 11, 12, 10, 8</p>
                                        <p>S: 15, 12, 13, 11, 8</p>
                                        <p>M: 16, 12, 13, 11, 9</p>
                                        <p>L: 18, 13, 14, 12, 10</p>
                                        <p className="form-hint">(thumb, index, middle, ring, pinky)</p>
                                    </div>
                                    <textarea placeholder="e.g. L: 11, 12, 13, 14, 15; R: 11, 12, 13, 14, 15" value={form.sizes} onChange={update('sizes')} className="form-textarea" rows={2} />
                                </div>

                                <div className="form-group">
                                    <label className="form-label">design details / inspo</label>
                                    <textarea placeholder="describe your design, link inspo pics, pinterest boards, etc." value={form.designDetails} onChange={update('designDetails')} className="form-textarea" rows={4} />
                                </div>

                                <div className="form-group">
                                    <label className="form-label">reference images (up to 5)</label>
                                    <p className="form-hint">upload inspo pics, screenshots, etc.</p>
                                    <label className="commission-btn commission-file-btn" style={{ display: 'inline-block', cursor: 'pointer' }}>
                                        choose files ✧
                                        <input type="file" accept="image/*" multiple onChange={handleImageChange} style={{ display: 'none' }} />
                                    </label>
                                    {refImages.length > 0 && (
                                        <div className="upload-previews">
                                            {refImages.map((item, i) => (
                                                <div key={i} className="upload-preview">
                                                    <img src={item.url} alt="" />
                                                    <button type="button" className="upload-remove" onClick={() => removeImage(i)}>×</button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label className="form-label">your name *</label>
                                    <input type="text" value={form.name} onChange={update('name')} className="form-input" />
                                </div>

                                <div className="form-group">
                                    <label className="form-label">preferred contact method *</label>
                                    <div className="form-radios">
                                        {['Phone', 'Email'].map((opt) => (
                                            <label key={opt} className="form-radio">
                                                <input type="radio" name="contactMethod" value={opt} checked={form.contactMethod === opt} onChange={(e) => setForm({ ...form, contactMethod: e.target.value, contactInfo: '' })} />
                                                <span>{opt}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {form.contactMethod && (
                                    <div className="form-group">
                                        <label className="form-label">{form.contactMethod === 'Phone' ? 'phone number' : 'email'} *</label>
                                        <input
                                            type={form.contactMethod === 'Phone' ? 'tel' : 'email'}
                                            placeholder={form.contactMethod === 'Phone' ? 'your phone number' : 'your email'}
                                            value={form.contactInfo}
                                            onChange={update('contactInfo')}
                                            className="form-input"
                                        />
                                    </div>
                                )}

                                <div className="form-group">
                                    <label className="form-label">date needed by *</label>
                                    <input type="date" value={form.dateNeeded} onChange={update('dateNeeded')} className="form-input" />
                                    {isRush && (
                                        <p className="form-hint" style={{ color: '#b35900', opacity: 1 }}>
                                            ✧ this is within 2 weeks, rush order fee of +$20 will be applied
                                        </p>
                                    )}
                                </div>

                                <button type="submit" className="commission-btn commission-submit-btn">
                                    add to cart 
                                </button>
                                {formErrors.length > 0 && (
                                    <div className="commission-form-errors">
                                        {formErrors.map((err, i) => (
                                            <p key={i} className="commission-form-error">✕ {err}</p>
                                        ))}
                                    </div>
                                )}
                            </form>
                            )}
                        </div>
                    </PageText>
                    <PageFooter />
                </PageBody>
            </PageContainer>
        </PageLayout>
    );
};
